import { useRef } from 'react';

import { Icon } from '@iconify/react';

import ActiveSectionRow from './ActiveSectionRow';
import SectionRow from './SectionRow';
import { ContentDataWithProgress, SectionDataWithProgress } from '../../../types/compound/progressTypes';
import { ContentData } from '../../../types/contentTypes';
import SectionData from '../../../types/SectionData';
import SkillData from '../../../types/skillData';

import './SectionList.scss';
import clsx from 'clsx';

const cursorGrab = {
  cursor: 'grab',
};

export type SectionRowCurrentSectionData = {
  section: SectionDataWithProgress | SectionData;
  contents: ContentDataWithProgress[];
};

interface SectionListProps {
  sections: SectionDataWithProgress[] | SectionData[];
  currentSectionData?: SectionRowCurrentSectionData;
  skill: SkillData;
  handleSwapOrder?: (sections: SectionData[] | ContentData[], index1: number, index2: number) => {} | undefined;
  isDraggable?: boolean;
  currentContentId?: string;
  editing?: boolean;
  className?: string;
}

export default function SectionList({
  sections,
  currentSectionData,
  skill,
  handleSwapOrder,
  isDraggable = false,
  currentContentId,
  editing = false,
  className,
}: SectionListProps) {
  const dragItem = useRef<any>(null);
  const dragOverItem = useRef<any>(null);

  const onDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
    handleSwapOrder?.(sections, dragItem.current - 1, dragOverItem.current - 1);
  };

  const SectionRows = sections.map(section => {
    if (currentSectionData && section.id === currentSectionData.section.id) {
      return (
        <ActiveSectionRow
          key={section.id}
          className="mb-3"
          section={currentSectionData.section}
          contents={currentSectionData.contents}
          currentContentId={currentContentId}
        />
      );
    } else {
      return isDraggable ? (
        <div
          draggable
          key={section.order}
          onDragStart={() => (dragItem.current = section.order)}
          onDragEnter={() => (dragOverItem.current = section.order)}
          onDragEnd={onDragEnd}
          onDragOver={e => e.preventDefault()}
          className="drag-section-row hover-border px-4 py-2"
        >
          <Icon icon="material-symbols:menu" style={cursorGrab} />
          <SectionRow key={section.id} section={section} skill={skill} editing={editing} />
        </div>
      ) : (
        <SectionRow
          className="hover-border px-8 py-2"
          key={section.id}
          section={section}
          skill={skill}
          editing={editing}
        />
      );
    }
  });

  return <div className={clsx('section-list', className)}>{SectionRows}</div>;
}
